import { useLazyQuery } from "@apollo/client/react";import React, { useMemo, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import {
  Button, Grid } from
'@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { GET_ALL_CODIGO_POSTAL } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getAllCodigoPostal';
import { adaptCodigoPostalArray } from '../../../adapters/frecuenciaDistribuidor/codigoPostalAdapter';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';



export const BuscarCodigoPostal = ({ open, onClose, onRowClick }) => {

  const [
  rows,
  handleChangePaginationStatus,
  paginationStatus,
  totalCount,
  filterStatus,
  setFilterStatus] =
  useGetCodigosPostal();

  const initialColumns = [
  {
    field: 'codigoPostal',
    headerName: 'Codigo Postal',
    flex: 0.1
  },
  {
    field: 'localidad',
    headerName: 'Localidad'
  },
  {
    field: 'provincia',
    headerName: 'Provincia'
  },
  {
    field: 'tipoZona',
    headerName: 'Tipo Zona',
    flex: 0.1

  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleCloseDlgProveedor = () => {
    onClose();
  };

  return (
    <CustomDialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
      title='Búsqueda de Códigos Postales'
      onCancel={handleCloseDlgProveedor}>
      
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2
        }}
        marginBottom={1}>
        
                <Grid size={{ xs: 1 }}>
                    <TextInput
            placeholder='Filtrar'
            value={filterStatus}
            searchIcon
            onChange={(e) => setFilterStatus(e.target.value)}
            onClearButtonClick={() => setFilterStatus(' ')} />
          
                </Grid>
            </Grid>
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2
        }}>
        
                <DataGridGenerico
          hideFooterPagination={false}
          toolbar={false}
          columns={columns}
          rows={rows}
          onPageChange={(page) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            page: page
          }))
          }
          onPageSizeChange={(pageSize) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            pageSize: pageSize,
            page: 0
          }))
          }
          pageSize={paginationStatus.pageSize}
          totalCount={totalCount}
          currentPage={paginationStatus.page}
          onRowClick={onRowClick} />
        
            </Grid>
        </CustomDialog>);

};


const useGetCodigosPostal = () => {
  const [codigosPostal, setCodigosPostal] = useState([]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getCodigosPostal, { data: codigosPostalData, loading: codigosPostalLoading }] = useLazyQuery(GET_ALL_CODIGO_POSTAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!codigosPostalData) return;
    setCodigosPostal(codigosPostalData);
  }, [codigosPostalData]);

  useEffect(() => {
    if (!codigosPostalLoading) {
      // getProveedores();
      getCodigosPostal({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
            { localidad: { contains: debouncedFilterValue } }]

          }
        }
      });
    }
  }, [paginationStatus, debouncedFilterValue]);
  return [
  adaptCodigoPostalArray(codigosPostal) || [],
  setPaginationStatus,
  paginationStatus,
  codigosPostal?.allCodigoPostal?.totalCount,
  filterStatus,
  setFilterStatus];

};